.rotation-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  height: 16px;
  svg {
    width: 16px;
    height: 16px;
  }
}
